import Vue from 'vue'
import Vuex from 'vuex'

import { root } from './modules/root'
import { devicePage } from '@/views/DevicePage/store.js'
import { homePage } from '@/views/HomePage/store.js'
import { systemLog } from '@/views/SystemLog/store.js'

Vue.use(Vuex)

const store = {
  strict: process.env.NODE_ENV !== 'production',
  ...root,
  modules: {
    devicePage,
    homePage,
    systemLog,
  },
}

export default new Vuex.Store(store)
